import { markRaw } from "vue";
import ActionErrorModalContent from "@/components/modals/ActionErrorModalContent.vue";
import type { ActionModalOptions, ActionModalStep, ErrorModalOptions } from "@/types/action-modal";

export const ACTION_ERROR_MODAL_STEP_ID = "action-error-modal-content";

export function createActionErrorSharedData(errorCode?: string, errorMessage?: unknown): Record<string, unknown> {
    return {
        actionErrorCode: errorCode || "",
        actionErrorMessage: errorMessage ?? null,
    };
}

export function createActionErrorModalStep(title: string, overrides: Partial<ActionModalStep> = {}): ActionModalStep {
    return {
        title,
        id: ACTION_ERROR_MODAL_STEP_ID,
        positionIconHeader: "left",
        displayFooter: true,
        displayCloseButton: true,
        component: markRaw(ActionErrorModalContent),
        ...overrides,
    };
}

export function createActionErrorModalOptions(options: ErrorModalOptions & { title: string }): ActionModalOptions {
    return {
        title: options.title,
        modalType: "danger",
        positionIconHeader: "left",
        displayFooter: true,
        displayCloseButton: true,
        stack: options.stack ?? true,
        maxWidth: options.maxWidth,
        callback: options.callback,
        customComponent: markRaw(ActionErrorModalContent),
        componentProps: {
            message: options.message,
            errorCode: options.errorCode,
            errorMessage: options.errorMessage,
        },
    };
}
